import React, { Component, PropTypes } from 'react';
import InlineSVG from 'svg-inline-react';

class CategoryIcon extends Component {

    static propTypes = {
        category: PropTypes.string
    };

    render() {

        var categoryName = this.props.category;

        if (categoryName === 'moving_cian') {
            categoryName = 'moving';
        }

        return (
            <div className="CategoryIcon">
                <InlineSVG src={require(`!svg-inline?removeSVGTagAttrs=false!./${categoryName}.svg`)} />
            </div>
        );
    }

}

export default CategoryIcon;



// WEBPACK FOOTER //
// ./client/components/CategoryIcon/CategoryIcon.js